"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_material_icon_1 = __importDefault(require("@material/react-material-icon"));

var fclasses_1 = require("@bodiless/fclasses");

var RichTextContext_1 = require("../RichTextContext");

var DefaultPluginButton = fclasses_1.Button;

var PluginButton = function PluginButton(props) {
  var componentName = props.componentName,
      icon = props.icon,
      children = props.children,
      rest = __rest(props, ["componentName", "icon", "children"]); // Workaround to get styled component from UI if it exists with fallback to original Component.


  var completeUI = RichTextContext_1.useUI();
  var StyledComponent;

  if (componentName && completeUI[componentName]) {
    StyledComponent = completeUI[componentName];
  } else {
    StyledComponent = DefaultPluginButton;
  }

  return react_1.default.createElement(StyledComponent, __assign({}, rest), children || react_1.default.createElement(react_material_icon_1.default, {
    className: "bl-material-icons",
    icon: icon
  }));
};

exports.default = PluginButton;